import React, { createContext, useContext, useState, useEffect } from "react";

// Create the context
export const CombinedContext = createContext();

// Corrected provider name
export const CombinedProvider = ({ children }) => {
  const [company, setCompany] = useState(null);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [locations, setLocations] = useState([]);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(false);
  const [allCompanies, setAllCompanies] = useState([]);

  function formatPrice(price) {
    const num = parseFloat(price);
    if (isNaN(num)) return "N/A";
    return num.toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }
  // console.log("The company is ",company);

  // Load initial state from storage
  useEffect(() => {
    const loadAuthData = () => {
      const authData =
        JSON.parse(localStorage.getItem("authData")) ||
        JSON.parse(sessionStorage.getItem("authData"));
      // console.log("i am working");

      if (authData) {
        setCompany(authData.company);
        setUser(authData);
      } else {
        setCompany(null);
        setUser(null);
      }
    };

    // Load auth data on mount
    loadAuthData();

    // Listen for storage events to handle changes from other tabs/windows
    const handleStorageChange = () => {
      loadAuthData();
    };

    window.addEventListener("storage", handleStorageChange);

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  const value = {
    company,
    setCompany,
    user,
    setUser,
    loading,
    setLoading,
    selectedCompany,
    setSelectedCompany,
    locations,
    setLocations,
    allCompanies,
    setAllCompanies,
    formatPrice,
  };

  return (
    <CombinedContext.Provider value={value}>
      {children}
    </CombinedContext.Provider>
  );
};

// Custom hook for consuming the unified context
export const useCombinedContext = () => {
  return useContext(CombinedContext);
};
